import { render, staticRenderFns } from "./inputEdit.vue?vue&type=template&id=c485087c&scoped=true"
import script from "./inputEdit.vue?vue&type=script&lang=js"
export * from "./inputEdit.vue?vue&type=script&lang=js"
import style0 from "./inputEdit.vue?vue&type=style&index=0&id=c485087c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c485087c",
  null
  
)

export default component.exports